import { FC, useEffect, useRef, useState } from 'react'
import styles from './WallOfLove.module.scss'
import { WallOfLoveCategory } from 'components/WallOfLove/wallOfLoveIterfaces'

interface FilterProps {
	items: WallOfLoveCategory[]
	selectItem: (item: WallOfLoveCategory) => void
	defaultItem: WallOfLoveCategory
	selectedItem?: WallOfLoveCategory
}

export const Filter: FC<FilterProps> = (props) => {
	const [selectedItem, setSelectedItem] = useState(props.defaultItem)
	const [showShadow, setShowShadow] = useState(false)
	const containerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		setSelectedItem(props.selectedItem)
	}, [props.selectedItem])

	useEffect(() => {
		const scrollHandler = () => {
			const scrollY = window.scrollY
			setShowShadow(scrollY > 0)
		}

		window.addEventListener('scroll', scrollHandler, { passive: true })
		return () => {
			window.removeEventListener('scroll', scrollHandler)
		}
	}, [])

	return (
		<div
			className={styles.filter_outer}
			style={{
				overflowX: 'auto',
				boxShadow: showShadow ? 'rgba(0, 0, 0, 0.15) 0px 30px 30px 0px' : 'none',
			}}
		>
			<div
				className={styles.filter_container}
				ref={containerRef}
			>
				{props.items.map((item, i) => {
					const selected = selectedItem === item
					return (
						<button
							key={i}
							id={`filter-${item}`}
							className={`${styles.filter_item} ${selected ? styles.selected : ''}`}
							onClick={() => {
								props.selectItem(item)
							}}
						>
							{item}
						</button>
					)
				})}
			</div>
		</div>
	)
}
